import _ from 'lodash';
import template from 'url-template';

import {
    FETCH_COMPANY_SITES,
    FETCH_SITES,
    SET_SITE,
    TOGGLE_SITE
} from './actionTypes';

import awsHeader from '../helpers/awsAuth';
import k2aBaseApi from '../apis/key2act';

import { handleNetworkError } from './applicationMessageActions';

const ClientSitesUrl = template.parse('/clients/{clientId}/sites{?searchFilter,limit}');
const CompanySitesUrl = template.parse('/companies/{companyId}/sites{?limit}');

const DEFAULT_PAGE_LIMIT = 200;

export const fetchCompanySites = (companyId, options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();

    options.limit || (options.limit = DEFAULT_PAGE_LIMIT);

    try {
        const healthData = getState().home.healthChecks;

        const result = await k2aBaseApi.get(
            CompanySitesUrl.expand({
                companyId,
                ...options
            }),
            header
        );

        const payload = _.chain(result).get('data.data', []).map(site => {
            const siteBuildingType= site.buildingType;
            return {
                ...site,
                buildingTypeId: siteBuildingType.id,
                priority:       _getPriority(site, healthData, 'site')
            };
        }).value();

        dispatch({
            type: FETCH_COMPANY_SITES,
            payload
        });
    } catch (error) {
        dispatch(handleNetworkError(error));
    }
};

export const fetchClientSites = (clientId, searchFilter = '', options = {}) => async dispatch => {
    const header = await awsHeader();

    options.limit || (options.limit = DEFAULT_PAGE_LIMIT);

    try {
        const result = await k2aBaseApi.get(
            ClientSitesUrl.expand({
                clientId,
                searchFilter,
                ...options
            }),
            header
        );

        const payload = _.get(result, 'data.data', []);

        const sites = payload.map(site => ({
            position: {
                lat: site.address ? site.address.latitude : 0,
                lng: site.address ? site.address.longitude : 0
            },
            name:         site.name,
            label:        site.name,
            title:        site.name,
            id:           site.id,
            address:      site.address,
            averageScore: null,
            deviceCount:  null,
            highestScore: null,
            lowestScore:  null,
            value:        site.id
        })).sort((a, b) => _sorter(a, b));

        dispatch({
            type:    FETCH_SITES,
            payload: sites
        });
    } catch (error) {
        dispatch(handleNetworkError(error));
    }
};

export const setSite = site => async dispatch => {
    dispatch(toggleSiteSelection(true));

    dispatch({
        type:    SET_SITE,
        payload: site
    });
};

export const toggleSiteSelection = isOpen => ({
    type:    TOGGLE_SITE,
    payload: isOpen
});

const _getPriority = (node, healthData, filter) => {
    let siteRuleEvents;

    if (filter === 'site') {
        siteRuleEvents = healthData.filter(item => item.siteId === node.id).sort((a, b) => a.priority - b.priority);
    }

    if (siteRuleEvents && siteRuleEvents.length) {
        return siteRuleEvents[0].priority;
    }

    return 0;
};

const _sorter = (a, b) => {
    let roleA = a.name.toUpperCase();
    let roleB = b.name.toUpperCase();

    if (roleA < roleB) {
        return -1;
    }
    if (roleA > roleB) {
        return 1;
    }

    return 0;
};
